import { useState, useEffect } from 'react';
// 🟢 FIXED: Import the centralized API file
import { connectivityAPI } from '../../api/connectivityApis/connectivity.api'; 
import { toast } from 'sonner';

export interface ChatSessionPreview {
  id: string;
  expert_code: string; // Needed for the chat URL routing
  other_party_name: string;
  category_name: string;
  status: string;
  started_at: string;
  duration_seconds: number;
}

export const useChatHistory = (role: 'user' | 'expert', code: string) => {
  const [sessions, setSessions] = useState<ChatSessionPreview[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      if (!code) return;
      
      try {
        setIsLoading(true);
        
        // 🟢 FIXED: Use our clean API file instead of raw axios
        const data = await connectivityAPI.getSessionHistoryInbox(role, code);
        
        const formattedSessions = data.map((session: any) => {
          const isMeExpert = role === 'expert';

          // If I am the expert, the other party is the user (from intake).
          // If I am the user, the other party is the expert (from category).
          const otherPartyName = isMeExpert 
            ? (session.intake_data?.userProfile?.name || 'Client') 
            : `Expert (${session.intake_data?.categoryName || 'General'})`;

          return {
            id: session.id,
            expert_code: session.expert_code, // Always keep this to build the /chat/EXP123 url
            other_party_name: otherPartyName,
            category_name: session.intake_data?.categoryName || 'General',
            status: session.status,
            started_at: session.started_at,
            duration_seconds: session.duration_seconds || 0,
          };
        });

        setSessions(formattedSessions);
      } catch (error) {
        console.error(`Failed to fetch ${role} messages:`, error);
        toast.error("Could not load message history.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchHistory();
  }, [role, code]);

  return { sessions, isLoading };
};